import { ReactNode } from 'react'
import clsx from 'clsx'
import * as styles from './styles.module.css'

export interface SectionItemProps {
  children?: ReactNode
}

const SectionItem = ({ children }: SectionItemProps): JSX.Element => (
  <>
    <div className={clsx(styles.section__item)}>{children}</div>
  </>
)

export default SectionItem
